module.exports = __webpack_public_path__ + "img/user.4d821c99.svg";